import { UserRole } from './types'

export function isImpersonatedUser(roles?: UserRole[]) {
  return roles?.includes(UserRole.ImpersonatedUser)
}
